import { Box } from 'enova-frontend-components';

import styled from '../../../styled';

export const EnergimerkeWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 235px 70px 30px 30px;
  //border-bottom: 1px solid #d2d5d8;
  padding: 10px 0 20px 0;
  gap: 5px;
`;

export const BarWrapper = styled(Box)`
  height: 30px;
  grid-column-start: 1;

  svg {
    width: auto;
    height: 30px;
  }
`;

export const KarakterWrapper = styled(Box)`
  grid-column-start: 2;
  height: 30px;

  svg {
    width: auto;
    height: 30px;
  }
`;
